import { AvatarType, type DisplayMode } from "@/entities/avatar-scenario/const/config";
import { useEffect } from "react";
import { useAvatarAgent } from "@/entities/avatar-scenario/model/use-avatar-agent";
import ThreeJSApp from "@/shared/lib/threejs/app";
import { useAvatarStore } from "@/shared/store/avatar-store";
import { useRealtimeAgentStore } from "@/shared/store/realtime-agent";
import { useVadStore } from "@/shared/store/vad";
import { useAgentWebsocketActions } from "@/entities/realtime-agent/model/use-agent-websocket";

//TODO: 아바타 자동 로드 (선언적으로 아바타를 세팅하면 더 좋겠다고 생각함. 하지만 로딩 상태 및 아바타의 로드를 완전히 위임하면 관리포인트가 늘어날 수 있음.)
//ex) 아바타를 교체할 때 등

export const useRenderAndAnimateAvatar = (app: ThreeJSApp | null, avatarType: AvatarType = "kikiz", displayMode: DisplayMode = 'web') => {
  const isThreejsAppReady = useAvatarStore((state) => state.isThreejsAppReady);
  const { selectAvatar, playAnimation, playLipSync, stopLipSync, onClickAvatar } = useAvatarAgent(app, displayMode);
  const setCurrentAnimation = useAvatarStore((state) => state.setCurrentAnimation);
  const setVadStatus = useVadStore((state) => state.setVadStatus);
  const clearCurrentTurn = useRealtimeAgentStore((state) => state.clearCurrentTurn);
  const { sendInterrupt } = useAgentWebsocketActions();

  //TODO: 아바타 자동 로드 (명령형 코드 개선 필요) - 렌더링 생명주기가 app으로 인해 복잡도가 증가함.
  useEffect(() => {
    if (isThreejsAppReady) {
      console.log('🎭 [USE-RENDER-AVATAR] selectAvatar 호출:', avatarType);
      selectAvatar(avatarType);
    }
  }, [isThreejsAppReady, avatarType, selectAvatar]);


  useEffect(() => {
    if (!isThreejsAppReady) return;

    onClickAvatar(() => {
      // 현재 진행 중인 턴이 있다면 interrupt 메시지 전송
      sendInterrupt();

      // 아바타 상태를 listening으로 변경
      setCurrentAnimation("listening");
      setVadStatus("listening");
      clearCurrentTurn();
    })
    return () => {
      onClickAvatar(() => { });
    }
  }, [onClickAvatar, setCurrentAnimation, setVadStatus, clearCurrentTurn, sendInterrupt, isThreejsAppReady]);

  // 애니메이션 요청 상태를 감지하고 실행하는 observer 로직
  useEffect(() => {
    const unsubscribe = useAvatarStore.subscribe((state) => state.currentAnimation, (currentAnimation) => {
      if (currentAnimation && app) {
        playAnimation(currentAnimation);
      }
    });
    return () => unsubscribe();
  }, [app, playAnimation]);

  useEffect(() => {
    const unsubscribe = useRealtimeAgentStore.subscribe((state) => state.currentChunk, (currentChunk) => {
      if (currentChunk && currentChunk !== "END" && currentChunk?.lipsync?.blendshapes) {
        playLipSync(currentChunk.lipsync.blendshapes);
      } else {
        stopLipSync();
      }
    });
    return () => unsubscribe();

  }, [app, playLipSync, stopLipSync]);

};